export { Tag } from './Tag.js';
//# sourceMappingURL=index.js.map
